import { Modal, Form, Button, InputGroup, Table, Dropdown, Row, Col } from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import "./../../assets/scss/new-entity-modal.scss";
import Select from "react-select";
import DatePickerCustomInput from "../utils/DatePickerCustomInput";
import { DeleteIcon, EditIcon, LockIcon, NoSelectedItemIcon } from "../Icons";
import NumberCustomInput from "../utils/NumberCustomInput";
import DateTime from "react-datetime";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { FieldArray, useFormik, FormikProvider } from "formik";
import { useMemo, useState } from "react";
import * as yup from "yup";
import CreatableSelect from "react-select/creatable";
import ItemSizeDialog from "../ItemSizeDialog";
import currency from "currency.js";
import moment from "moment";
import PurchaseDialog from "../PurchaseDialog";
import { toast } from "react-toastify";
import CachedIcon from "mdi-react/CachedIcon";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import { Popover } from "react-tiny-popover";
import ItemsTable from "../utils/ItemsTable";
import CurrencyInput from "react-currency-input-field";
import {
  convertFromBaseCurrency,
  convertToBaseCurrency,
  fetchActionsUtil,
  qtyFormat,
  qtyFormatToString,
  scrollToElement,
  unitsResolver,
  amountTypes,
  formatDate,
} from "../../utils/helpers";
import ConfirmDialogue from "../ConfirmDialogue";
import { isEmpty, values } from "lodash";
import { useStoreActions, useStoreState } from "easy-peasy";
import { useRef, useEffect } from "react";
import DotsVerticalIcon from "mdi-react/DotsVerticalIcon";
import ModalLoader from "../utils/ModalLoader";
import { appSettings, durationOptions } from "../../config";
import { trim } from "lodash";
import AddItemSizeDialog from "../modals/AddItemSizeModal";
import {
  useCurrencies,
  useIsAdmin,
  useIsCashier,
  useTaxOptions,
  useUnits,
} from "../../utils/hooks";
import ConfirmDialog from "../ConfirmDialogue";

import { addDays, addMonths, addWeeks } from "date-fns";
import { useNavigate } from "react-router-dom";
import { FilesAttachments } from "../../utils/Attachments";
import CurrencyCustomInput from "../utils/CurrencyCustomInput";
import { queryActions } from "../../utils/reactQueryActions";
import { useAuth } from "../../hooks/useAuth";
import ItemsPayment from "../ItemsPayment";
import { formatForQty } from "../../utils/helpers";
import ExpensesSelector from "../utils/ExpensesSelector";

const usageOptions = [
  {
    label: "Sales",
    value: "Sales",
  },
  {
    label: "Office Use",
    value: "Office Use",
  },
  {
    label: "Promo",
    value: "Promo",
  },
];

export default function RaisePurchaseRequestGrn({
  showUpdateInventoryModal = true,
  setShowUpdateInventoryModal,
  defaultTableData = [],
  onHideIt,
  refetch,
  ignoreAllDuplicateInvoiceChecks = false,
  requisition,
  noVendorAccounting = false,
  onGRNPosted,
  taxType,
}) {
  const { deploymentCurrencies: currenciesOptions } = useCurrencies();
  const [isLoading, setIsLoading] = useState(false);
  const barcodeInputRef = useRef();
  const itemMeasurements = useStoreState(state => state.itemMeasurements);
  const { backendUrl, token } = useAuth();
  const queryClient = useQueryClient();
  const [showItemsPopover, setShowItemsPopover] = useState(false);
  const [showBatchItemsPopover, setShowBatchItemsPopover] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [tableData, setTableData] = useState([...defaultTableData] || []);
  const [mainNum, setMainNum] = useState(0);
  const [payment, setPayment] = useState({
    Payment: "Credit",
    From: "",
  });
  const [paymentFreight, setPaymentFreight] = useState({
    Payment: "Credit",
    From: "",
  });

  const [serialNumValue, setSerialNumValue] = useState("");

  const generalSettings = useStoreState(state => state.generalSettings);
  const isAdmin = useIsAdmin();
  const isCashier = useIsCashier();
  const { Units, getUnitLabelByValue } = useUnits();
  const navigate = useNavigate();
  const taxOptions = useTaxOptions();
  const [postToSales, setPostToSales] = useState(false);
  const setUp = async department => {
    let response = await fetch(`${backendUrl}/api/items/set-up?withVendorBalance=true`, {
      method: "GET",
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
        Authorization: `Bearer ${token}`,
      },
      credentials: "include",
    });

    const { storage } = await fetchActionsUtil(`${backendUrl}/api/items/storage-location`, "GET");

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const { data } = await response.json();

    data.vendors = data?.vendors
      .filter(el => el.Vendor_ID)
      .map(el => ({
        ...el,
        label: trim(el.CompanyName),
        value: el.Vendor_ID,
      }));

    data.itemMeasurement = data?.itemMeasurement.map(el => ({
      label: el.Size,
      value: el.Size,
    }));

    data.categories = data.categories.map(el => ({
      value: el.Cat_Name,
      label: el.Cat_Name,
    }));

    data.products = data.products.map(el => ({
      value: el.Product_Name,
      label: el.Product_Name,
    }));

    data.storage = storage?.map(el => ({
      value: el.storageID,
      label: el.name,
    }));

    data.farmlands = data.farmlands?.map(el => ({
      value: el.farmland,
      label: el.farmland,
    }));

    return data;
  };
  const {
    data = {
      vendors: [],
      itemMeasurement: [],
    },
    refetch: refetchSetup,
    isFetching: isFetchingSetup,
  } = useQuery([queryActions.ITEMS_SETUP], () => setUp(), {
    enabled: true,
  });

  const formik = useFormik({
    initialValues: {
      Vendor: "",
      Item_Type: "Inventory",
      Bar_Code: "",
      Item_Name: "",
      InvoiceNo: "",
      Size: "",
      Unit: "",
      Usage: "Sales",
      UnitPrice: 0,
      PurchasePrice: 0,
      Freight: 0,
      UnitCost: 0,
      Quantity: "",
      ManDate: moment(),
      ExpireDate: "",
      Date_Log: moment(),
      Product_Name: "",
      Cat_Name: "",
      Branch: "HQ",
      Tax: 0,
      Vat_5: 0,
      MaximumLevel: 0,
      DriverName: "",
      DriverPhoneNumber: "",
      TruckNumber: "",
      DeliveryDate: moment(),
      Reorder_Level: 0,
      sizes: [],
      Margin: 0,
      Incentive: 0,
      freightVendor: "",
      currency: requisition?.currency || generalSettings?.prevailingCurrency,
      conversionAmount: requisition?.conversionAmount || generalSettings.dollarInBaseCurrency,
      discountType: "Per Item",
      discount: 0,
      marginType: "Fixed",
      marginPercentage: "",
      incentiveType: "Fixed",
      incentivePercentage: "",
      Batch_Name: "",
      age: 0,
      ageDurationValue: "Week",
      parentBatchBarCode: "",
      parentBatchItemName: "",
      parentBatchName: "",
      parentBatchUnitCost: 0,
      StorageLocation: "",
      pcsPriceDistributor: 0,
      markUp: 0,
      markUpType: "Fixed",
      markUpPercentage: "",
      Pack_Size: "",
      Generic_Configuration: "",
      Tier: "",
      Branded_Generic: "",
      serialNumbers: [],
      taxType: taxType || "None",
      POId: "",
      restaurantMenu: false,
      invoiceFile: [],
      deductTax: false,
      expenseAccountID: "",
      expenseAccountDescription: "",
      expenseAccountType: "",
    },
    validationSchema: yup.object().shape({
      Bar_Code: yup.string().required("Item Code is required"),
      Item_Name: yup.string().required("Item Name is required"),
      InvoiceNo: yup.string().required("Invoice number is required"),
      // POId: yup.string().required("PO  number is required")
      Product_Name: yup.string().required("required"),
      Cat_Name: yup.string().required("required"),
      Vendor: yup.string().required(),
      UnitPrice: yup.string().required(),
      UnitCost: yup.string().required(),
      Quantity: yup.string().required(),
      Unit: yup.string().required(),
    }),
    onSubmit: async values => {
      // Serial numbers

      if (generalSettings.itemsRequiresSerialNumber) {
        if (Number(values.Quantity) !== values.serialNumbers.length) {
          return formik.setFieldError(
            "serialNumbers",
            "Number of serial numbers must match the Quantity"
          );
        }
      }

      //  Settings
      if (
        Number(values?.PurchasePrice) === 0 &&
        generalSettings.isPurchasePriceRequired &&
        !isAdmin
      ) {
        return formik.setFieldError("PurchasePrice", "Cost Price is required");
      }

      if (
        Number(values?.PurchasePrice) === 0 &&
        isAdmin &&
        !(await ConfirmDialog({
          title: "Cost Price Required",
          description: "Cost not set do you want to submit",
        }))
      ) {
        return;
      }

      values.vendorName = data?.vendors.find(el => el.value === values.Vendor)?.label;
      values.InvoiceAmount = InvoiceAmount;
      values.AmountDue = InvoiceAmount;
      values.Total_Freight = Total_Freight;

      // save for original values incase needed
      values.ogUnitPrice = selectedItem.UnitPrice;
      values.ogUnitCost = selectedItem.UnitCost;
      values.ogTax = selectedItem.Tax;
      values.ogVat_5 = selectedItem.Vat_5;

      values.totalLandingCost = totalLandingCost;
      const foundIndex = tableData.findIndex(
        el => el.Bar_Code === values.Bar_Code && el?.Batch_Name == values.Batch_Name
      );

      if (foundIndex !== -1) {
        tableData[foundIndex] = values;
        setTableData([...tableData]);
      } else {
        setTableData([...tableData, values]);
      }

      // formik.resetForm();
      formik.setFieldValue("InvoiceNo", values.InvoiceNo);
      formik.setFieldValue("Vendor", values.Vendor);
      formik.setFieldValue("discountType", values.discountType);
      formik.setFieldValue("discount", values.discount);
      formik.setFieldValue("POId", values.POId);
    },
    onReset: () => {
      // handleSelectedItem(null);
    },
  });

  const hasServiceItems = useMemo(
    () => tableData.find(item => item?.Bar_Code.includes("SERVICE")),
    [tableData]
  );

  const currencySymbol = useMemo(() => {
    const foundCurrency = currenciesOptions.find(el => el.cc === formik.values.currency);
    return foundCurrency ? foundCurrency.symbol : "";
  }, [formik.values.currency]);

  const discountPerItem = useMemo(() => {
    return formik.values.discountType === "Per Item" ? formik.values.discount : 0;
  }, [formik.values.discountType, formik.values.discount]);

  const discountTotalInvoice = useMemo(() => {
    return formik.values.discountType === "Total Invoice" ? formik.values.discount : 0;
  }, [formik.values.discountType, formik.values.discount]);

  const [invoiceDiscount, setInvoiceDiscount] = useState(0);
  const totalDiscount = useMemo(() => {
    const totalDiscountOnTableData = tableData
      .map(el => el.discount)
      .reduce(
        (a, b) =>
          currency(a, {
            precision: 2,
          }).add(b).value,
        0
      );
    return currency(totalDiscountOnTableData).add(invoiceDiscount).value;
  }, [tableData, invoiceDiscount]);

  const totalInvoiceAmount = useMemo(() => {
    return currency(
      tableData
        .map(el => el.InvoiceAmount)
        .reduce(
          (a, b) =>
            currency(a, {
              precision: 2,
            }).add(b),
          0
        ),
      {
        symbol: currencySymbol,
      }
    ).format();
  }, [tableData]);

  const totalLandingCost = useMemo(() => {
    return currency(formik.values.UnitCost, {
      symbol: "",
      separator: "",
    })
      .multiply(formik.values.Quantity)
      .format();
  }, [formik.values.UnitCost, formik.values.Quantity]);

  useEffect(() => {
    if (generalSettings.isFarm && formik.values?.parentBatchUnitCost && formik.values?.Quantity) {
      formik.setFieldValue(
        "PurchasePrice",
        currency(formik.values?.parentBatchUnitCost).divide(formik.values.Quantity).value
      );
    }
  }, [formik.values.Quantity, formik.values.parentBatchUnitCost]);

  useEffect(() => {
    const UnitCost = currency(formik.values.PurchasePrice, {
      symbol: "",
      separator: "",
    })
      .subtract(discountPerItem)
      .add(formik.values.Freight)
      .format();
    formik.setFieldValue("UnitCost", UnitCost);
  }, [formik.values.PurchasePrice, formik.values.Freight, discountPerItem]);

  //For Incentive
  useEffect(() => {
    if (formik.values.markUpType === "Percentage") {
      formik.setFieldValue(
        "markUp",
        currency(formik.values.markUpPercentage)
          .divide(100)
          .multiply(formik.values.UnitCost).value
      );
    }

    if (formik.values.incentiveType === "Percentage") {
      formik.setFieldValue(
        "Incentive",
        currency(formik.values.incentivePercentage)
          .divide(100)
          .multiply(formik.values.markUp).value
      );
    }

    if (formik.values.marginType === "Percentage") {
      formik.setFieldValue(
        "Margin",
        currency(formik.values.marginPercentage)
          .divide(100)
          .multiply(formik.values.markUp).value
      );
    }
  }, [
    formik.values.UnitCost,
    formik.values.marginPercentage,
    formik.values.incentivePercentage,
    formik.values.marginType,
    formik.values.incentiveType,
    formik.values.markUp,
    formik.values.markUpType,
    formik.values.markUpPercentage,
  ]);

  useEffect(() => {
    if (appSettings.hasIncentive) {
      const UnitPrice = currency(formik.values.UnitCost)
        .add(formik.values.Incentive)
        .add(formik.values.Margin).value;

      formik.setFieldValue("UnitPrice", UnitPrice);
      formik.setFieldValue("Tax", UnitPrice);
      formik.setFieldValue("Vat_5", UnitPrice);
    }
  }, [formik.values.UnitCost, formik.values.Margin, formik.values.Incentive]);

  const updateItem = async payload => {
    // convert each item to base currency if necessary
    payload.stockItems = payload.stockItems.map(item =>
      item.currency && item.currency !== generalSettings?.prevailingCurrency
        ? convertToBaseCurrency({
            data: item,
            conversionAmount: item.conversionAmount,
          })
        : item
    );

    // taxValue conversion
    if (payload.stockItems[0].currency !== generalSettings?.prevailingCurrency) {
      const convertedData = convertToBaseCurrency({
        data: {
          taxValue: payload.taxValue,
        },
        conversionAmount: payload.stockItems[0].conversionAmount,
      });
      payload.taxValue = convertedData.taxValue;
    }

    const formData = new FormData();
    formData.append("payload", JSON.stringify(payload));

    // Attachments
    if (payload?.invoiceFile) {
      for (const file of payload.invoiceFile) {
        formData.append(`invoiceFile`, file);
      }
    }

    const finalUrl = !noVendorAccounting
      ? `${backendUrl}/api/invexcloud/raise-grn-from-purchase-request`
      : `${backendUrl}/api/invexcloud/raise-grn-from-purchase-request-no-vendor-accounting`;

    let response = await fetch(finalUrl, {
      method: "POST",
      credentials: "include",
      body: formData,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const res = await response.json();
    return res;
  };

  const updateMutation = useMutation(payload => updateItem(payload), {
    onSuccess: ({ message, data }) => {
      toast.success(message);

      if (onGRNPosted && !noVendorAccounting) {
        onGRNPosted();
      }

      formik.resetForm();
      if (refetch) refetch();
      setShowUpdateInventoryModal(false);
      onHideIt && onHideIt();
    },
    onError: ({ message = "" }) => {
      toast.error(`Unable to perform action: ${message}`);
      if (message.includes("Invoice Exist")) {
        invoiceExists({
          message,
        });
      }
    },
  });

  const invoiceExists = async ({ message }) => {
    if (
      await ConfirmDialogue({
        title: message,
        description: "continue ?",
        type: "danger",
      })
    ) {
      saveMulti({
        ignoreDuplicateInvoice: true,
      });
    }
  };

  const InvoiceAmount = useMemo(
    () =>
      currency(formik.values.PurchasePrice, {
        symbol: "",
        separator: "",
      })
        .multiply(formik.values.Quantity)
        .format(),
    [formik.values.PurchasePrice, formik.values.Quantity]
  );

  const Total_Freight = useMemo(
    () =>
      currency(formik.values.Freight, {
        symbol: "",
        separator: "",
      })
        .multiply(formik.values.Quantity)
        .format(),
    [formik.values.Freight, formik.values.Quantity]
  );

  const getItemSizes = item => {
    return new Promise(async (resolve, reject) => {
      try {
        setIsLoading(true);
        let response = await fetch(`${backendUrl}/api/items/get-item/${item.Bar_Code}`, {
          headers: {
            Accept: "Application/json",
            "Content-Type": "Application/json",
          },
          credentials: "include",
        });

        if (!response.ok) {
          response = await response.json();
          toast.error(response.message);
        } else {
          const {
            data: { sizes },
          } = await response.json();

          resolve(sizes);
        }
      } catch (err) {
        console.log(err);
        toast.error("Unable to perform action");
        reject();
      } finally {
        setIsLoading(false);
      }
    });
  };

  const handleSelectedItem = async item => {
    // Validate item
    if (item?.Item_Type === "Service") {
      toast.error("A Service cannot be Restocked, Select another");
      return;
    }

    if (item?.currency && item?.currency !== generalSettings?.prevailingCurrency) {
      item = convertFromBaseCurrency({
        data: item,
        conversionAmount: item.conversionAmount,
      });
    }

    // console.log(item);
    setShowItemsPopover(false);
    const sizes = appSettings.hasSize ? await getItemSizes(item) : [];

    formik.resetForm();
    item.Vendor = trim(item.Vendor);

    const oldVendor = data.vendors.find(el => el.value === item.Vendor || el.label === item.Vendor);

    // console.log("oldVendor => ", oldVendor);

    const foundItem = tableData.find(el => el.Bar_Code === item.Bar_Code);
    const canPresetItemValues = (!foundItem && generalSettings.presetItemValues) || isAdmin;

    formik.setValues({
      ...formik.values,
      Vendor: !isEmpty(tableData) ? tableData[0].Vendor : "",
      Item_Type: item.Item_Type,
      Bar_Code: item.Bar_Code,
      Item_Name: item.Item_Name,
      // InvoiceNo: "",
      Size: item.Item_Desc,
      Unit: item.Product_Model,
      Usage: item.Usage,
      UnitPrice: canPresetItemValues ? item.UnitPrice : 0,
      UnitCost: canPresetItemValues ? item.UnitCost : 0,
      // Quantity: "",
      ManDate: moment(new Date(item.ManDate)),
      ExpireDate: moment(new Date(item.ExpireDate)),
      Date_Log: !isEmpty(tableData) ? tableData[0].Date_Log : moment(new Date()),
      Product_Name: item.Product_Name,
      Cat_Name: item.Cat_Name,
      Branch: item.Branch,
      MaximumLevel: item?.MaximumLevel,

      Tax: canPresetItemValues ? item.Tax : 0,
      Vat_5: canPresetItemValues ? item.Vat_5 : 0,
      PurchasePrice: canPresetItemValues ? item.UnitCost : 0,
      Reorder_Level: item.Reorder_Level,
      sizes: sizes ? sizes.map(el => ({ ...el, Quantity: 0 })) : [],

      //-----------------------
      Margin: canPresetItemValues ? item.Margin : 0,
      Incentive: canPresetItemValues ? item.Incentive : 0,

      //-----------------------
      currency: item?.currency ? item.currency : generalSettings?.prevailingCurrency,
      conversionAmount: item.conversionAmount,
      pcsPriceDistributor: canPresetItemValues ? item?.pcsPriceDistributor : 0,
      // ----------------------

      ...(canPresetItemValues
        ? {
            marginType: item.marginType,
            marginPercentage: item.marginPercentage,
            incentiveType: item.incentiveType,
            incentivePercentage: item.incentivePercentage,
            markUp: item.markUp,
            markUpType: item.markUpType,
            markUpPercentage: item.markUpPercentage,
          }
        : {}),

      Pack_Size: item.Pack_Size,
      Generic_Configuration: item.Generic_Configuration,
      Tier: item.Tier,
      Branded_Generic: item.Branded_Generic,
    });

    // save for original values incase needed
    item.ogUnitPrice = item.UnitPrice;
    item.ogUnitCost = item.UnitCost;
    item.ogTax = item.Tax;
    item.ogVat_5 = item.Vat_5;

    //----

    setSelectedItem(item);
    scrollToElement('input[name="Quantity"]', { scroll: false });
  };

  const arrangeItems = (item, allVendors) => {
    if (item?.currency && item?.currency !== generalSettings?.prevailingCurrency) {
      item = convertFromBaseCurrency({
        data: item,
        conversionAmount: item.conversionAmount,
      });
    }

    // console.log(item);
    const sizes = [];

    item.Vendor = trim(item.Vendor);

    const oldVendor = allVendors.find(el => el.value === item.Vendor || el.label === item.Vendor);

    const foundItem = tableData.find(el => el.Bar_Code === item.Bar_Code);
    const canPresetItemValues = (!foundItem && generalSettings.presetItemValues) || isAdmin;

    const incomingItems = {
      ...formik.values,
      Vendor: oldVendor?.value,
      Item_Type: item.Item_Type,
      Bar_Code: item.Bar_Code,
      Item_Name: item.Item_Name,
      InvoiceNo: item.InvoiceNo,
      Size: item.Item_Desc,
      Unit: item.Product_Model,
      Usage: item.Usage,
      UnitPrice: item.UnitPrice,
      UnitCost: item.UnitCost,
      Quantity: item?.Quantity,
      ManDate: moment(new Date(item.ManDate)),
      ExpireDate: moment(new Date(item.ExpireDate)),
      Date_Log: moment(new Date()),
      Product_Name: item.Product_Name,
      Cat_Name: item.Cat_Name,
      Branch: item.Branch,

      Tax: canPresetItemValues ? item.Tax : 0,
      Vat_5: canPresetItemValues ? item.Vat_5 : 0,
      PurchasePrice: canPresetItemValues ? item.UnitCost : 0,
      Reorder_Level: item.Reorder_Level,
      sizes: sizes ? sizes.map(el => ({ ...el, Quantity: 0 })) : [],

      //-----------------------
      Margin: canPresetItemValues ? item.Margin : 0,
      Incentive: canPresetItemValues ? item.Incentive : 0,

      //-----------------------
      currency: item?.currency ? item.currency : generalSettings?.prevailingCurrency,
      conversionAmount: item.conversionAmount,
      pcsPriceDistributor: canPresetItemValues ? item?.pcsPriceDistributor : 0,
      // ----------------------

      ...(canPresetItemValues
        ? {
            marginType: item.marginType,
            marginPercentage: item.marginPercentage,
            incentiveType: item.incentiveType,
            incentivePercentage: item.incentivePercentage,
            markUp: item.markUp,
            markUpType: item.markUpType,
            markUpPercentage: item.markUpPercentage,
          }
        : {}),

      Pack_Size: item.Pack_Size,
      Generic_Configuration: item.Generic_Configuration,
      Tier: item.Tier,
      Branded_Generic: item.Branded_Generic,

      //--------------------------------------
      requestid: item?.requestid,
      POId: item?.POId,
    };

    // save for original values incase needed
    item.ogUnitPrice = item.UnitPrice;
    item.ogUnitCost = item.UnitCost;
    item.ogTax = item.Tax;
    item.ogVat_5 = item.Vat_5;
    item.ogQuantity = item.Quantity;

    const selectedItem = item;

    //---- In the submkit
    const amountInv = currency(incomingItems.PurchasePrice, {
      symbol: "",
      separator: "",
    })
      .multiply(incomingItems.Quantity)
      .format();

    const totalfrigh = currency(incomingItems.Freight, {
      symbol: "",
      separator: "",
    })
      .multiply(incomingItems.Quantity)
      .format();

    const totalLand = currency(incomingItems.UnitCost, {
      symbol: "",
      separator: "",
    })
      .multiply(incomingItems.Quantity)
      .format();

    if (appSettings.hasIncentive) {
      const UnitPrice = currency(incomingItems.UnitCost)
        .add(incomingItems.Incentive)
        .add(incomingItems.Margin).value;

      incomingItems.UnitPrice = UnitPrice;
      incomingItems.Tax = UnitPrice;
      incomingItems.Vat_5 = UnitPrice;
    }

    incomingItems.vendorName = allVendors.find(el => el.value === incomingItems.Vendor)?.label;

    incomingItems.InvoiceAmount = amountInv;
    incomingItems.AmountDue = amountInv;
    incomingItems.Total_Freight = totalfrigh;

    // save for original values incase needed
    incomingItems.ogUnitPrice = selectedItem.UnitPrice;
    incomingItems.ogUnitCost = selectedItem.UnitCost;
    incomingItems.ogTax = selectedItem.Tax;
    incomingItems.ogVat_5 = selectedItem.Vat_5;
    incomingItems.ogQuantity = selectedItem.Quantity;

    incomingItems.totalLandingCost = totalLand;

    return incomingItems;
  };

  const handleSelectedItemToEdit = item => {
    formik.resetForm();
    formik.setValues({
      ...formik.values,
      ...item,
    });
    setSelectedItem(item);
    setShowItemsPopover(false);
    scrollToElement('input[name="Quantity"]', { scroll: false });
  };

  const deleteItem = async payload => {
    let response = await fetch(`${backendUrl}/api/items/delete`, {
      method: "POST",
      credentials: "include",
      body: JSON.stringify(payload),
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };
  const deleteMutation = useMutation(payload => deleteItem(payload), {
    onSuccess: ({ message }) => {
      toast.success(message);
      formik.resetForm();
      setSelectedItem(null);
    },
    onError: ({ message = "" }) => {
      toast.error(`Unable to perform action: ${message}`);
    },
  });

  const handleDeleteItem = async () => {
    if (isEmpty(selectedItem)) return toast.error("No Item Selected");

    if (
      await ConfirmDialogue({
        title: "Delete Item",
        description: "Are you sure you want to delete this Item from your inventory",
      })
    ) {
      deleteMutation.mutate(selectedItem);
    }
  };

  const handleRemoveItem = index => {
    setTableData([...tableData.filter((el, i) => i !== index)]);
  };

  const saveMulti = async ({ ignoreDuplicateInvoice = false }) => {
    if (hasServiceItems && isEmpty(formik.values.expenseAccountID)) {
      return toast.error("Please select Account Posting for service");
    }

    if (
      await ConfirmDialog({
        title: "Raise GRN",
        description: "Are you sure?",
      })
    ) {
      // RECORDING A PENDING TABLE FOR STORE, BUT RECORD ACCOUNTING
      updateMutation.mutate({
        isMulti: true,
        stockItems: tableData,
        taxValue,
        taxType: formik.values.taxType,
        deductTax: formik.values.deductTax,
        ignoreDuplicateInvoice,
        vendorPaymentData: payment,
        vendorFreightPaymentData: paymentFreight,
        invoiceFile: formik.values.invoiceFile,
        ignoreAllDuplicateInvoiceChecks,
        requisitionTitle: requisition.title,
        requestid: requisition.requestid,
        //=========================================================
        expenseAccountID: formik.values.expenseAccountID,
        expenseAccountDescription: formik.values.expenseAccountDescription,
        expenseAccountType: formik.values.expenseAccountType,
      });
    }
  };

  const getSelectedVendorBalance = vendor => {
    const vendorData = data?.vendors?.find(el => el.value === vendor || el.label === vendor);
    return vendorData ? vendorData?.balance : 0;
  };

  const sizeAndColor = async () => {
    if (Number(formik.values.Quantity) === 0) {
      toast.error("Please enter quantity");
      formik.setFieldError("Quantity", "Please enter quantity");
      return;
    }

    const data = await AddItemSizeDialog({
      item: formik.values,
      maxQuantity: formik.values.Quantity,
      previousSizes: formik.values.sizes,
    });

    if (data === false) return;

    formik.setFieldValue("sizes", data?.sizesAndColours ? data.sizesAndColours : []);
  };

  const getBatches = async selectedItemFromPopover => {
    try {
      setIsLoading(true);

      let response = await fetch(
        `${backendUrl}/api/items/batches-for-sales/${selectedItemFromPopover.Bar_Code}`,
        {
          method: "GET",
          headers: {
            Accept: "Application/json",
            "Content-Type": "Application/json",
          },
          credentials: "include",
        }
      );

      if (!response.ok) {
        response = await response.json();
        throw new Error();
      } else {
        const {
          data: { /*  batches = [], sizes = [], */ item = {} },
        } = await response.json();
        if (item) {
          handleSelectedItem(item);
        } else {
          toast.error("Item not found");
        }
      }
    } catch (err) {
      console.log(err);
      toast.error("Unable to load batches, Try again");
    } finally {
      setIsLoading(false);
    }
  };

  /*   useEffect(() => {
    //  console.log(POItems);
    if (POItems) {
      const getallItems = async () => {
        try {
          const alreadyAdded = POItems?.filter(el => el?.quantity !== el?.receiveQuantity);
          const element = await fetchActionsUtil(
            `${backendUrl}/api/vendors/get-PO-choose-items`,
            "POST",
            "",
            { POItems: alreadyAdded }
          );
          //
          const allVendors = element?.vendors.map(el => ({
            ...el,
            label: trim(el.CompanyName),
            value: el.Vendor_ID,
          }));
          const returnItems = element?.data?.map(el => arrangeItems(el, allVendors));
          setMainNum(returnItems.length);
          setTableData(returnItems);
        } catch (error) {
          toast.error("Server Error");
          console.log(error);
        }
      };

      getallItems();
    }
  }, [POItems]); */

  useEffect(() => {
    const age = formik.values.age;
    const ageDurationValue = formik.values.ageDurationValue;

    const manufacturedDate =
      ageDurationValue === "Day"
        ? addDays(new Date(), -Number(age))
        : ageDurationValue === "Week"
        ? addWeeks(new Date(), -Number(age))
        : ageDurationValue === "Month"
        ? addMonths(new Date(), -Number(age))
        : new Date();

    formik.setFieldValue("ManDate", manufacturedDate);
  }, [formik.values.age, formik.values.ageDurationValue]);

  const handleSelectedBatchItem = batchItem => {
    formik.setFieldValue("parentBatchBarCode", batchItem.Bar_Code);
    formik.setFieldValue("parentBatchItemName", batchItem.ItemName);
    formik.setFieldValue("parentBatchName", batchItem.Batch_Name);
    formik.setFieldValue("parentBatchUnitCost", batchItem.UnitCost);
    formik.setFieldValue("PurchasePrice", batchItem.UnitCost);
    setShowBatchItemsPopover(false);
  };

  const createSerialNumbers = e => {
    const array = [...formik.values.serialNumbers, { serialNum: serialNumValue }];
    formik.setFieldValue("serialNumbers", array);
    formik.setFieldValue("Quantity", array?.length);
    e.target.value = "";
  };

  const taxValue = useMemo(() => {
    const taxType = taxOptions.find(el => el.value === formik.values.taxType);
    return currency(totalInvoiceAmount, {
      symbol: "",
      separator: "",
    })
      .multiply(taxType?.percentage)
      .format();
  }, [totalInvoiceAmount, formik.values.taxType]);

  //Total_Freight:

  const totalFreight = useMemo(() => {
    return tableData
      .map(el => el.Total_Freight)
      .reduce(
        (a, b) =>
          currency(a, {
            precision: 2,
          }).add(b).value,
        0
      );
  });

  useEffect(() => {
    setPayment({
      ...payment,
      vendorPaymentAmount: currency(totalInvoiceAmount).value,
    });
    setPaymentFreight({
      ...paymentFreight,
      vendorPaymentAmount: currency(totalFreight).value,
    });
  }, [totalInvoiceAmount, totalFreight]);

  const getPOItemsById = async PoID => {
    if (PoID) {
      try {
        const element = await fetchActionsUtil(
          `${backendUrl}/api/vendors/get-PO-items-by-ID`,
          "POST",
          "",
          { PoID }
        );
        //

        let removedNull = element?.data?.filter(el => el !== null);

        removedNull = removedNull?.filter(
          el => el?.warehouseCategory === "" || el?.warehouseName === ""
        );

        const allVendors = element?.vendors.map(el => ({
          ...el,
          label: trim(el.CompanyName),
          value: el.Vendor_ID,
        }));
        const returnItems = removedNull?.map(el => arrangeItems(el, allVendors));

        setMainNum(returnItems.length);
        setTableData(returnItems);
      } catch (error) {
        toast.error("Server Error");
        console.log(error);
      }
    }
  };

  // GA ===============================================================
  const [showJournalPopover, setShowJournalPopover] = useState(false);
  const handleSelectedAccount = account => {
    formik.setFieldValue("expenseAccountID", account?.AccountID);
    formik.setFieldValue("expenseAccountDescription", account?.Description);
    formik.setFieldValue("expenseAccountType", account?.Type);
    setShowJournalPopover(false);
  };
  // ==================================================================

  return (
    <Modal
      show={showUpdateInventoryModal}
      onHide={() => setShowUpdateInventoryModal(false)}
      dialogClassName={`new-entity-modal multi-update w-md-75`}
      backdropClassName={`global-backdrop`}
      centered={true}
      animation={false}
      enforceFocus={false}
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h1>
            {hasServiceItems && tableData?.length === 1 ? `Job Completion` : "Raise GRN"}
            <Button variant="">
              <CachedIcon onClick={() => refetchSetup()} className="text-primary" />{" "}
            </Button>
          </h1>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={`px-0 d-md-flex`}>
        <div className="p-4 w-100 pt-0">
          {/* <Form.Label className="mb-2">Currency</Form.Label> */}
          <div className="d-flex gap-2  mb-3 pb-2">
            <Form.Group>
              <Select
                classNamePrefix="form-select"
                placeholder="Select Currency"
                isSearchable={false}
                options={currenciesOptions}
                value={currenciesOptions.find(el => el.value === formik.values.currency)}
                onChange={({ value }) => {
                  formik.setFieldValue("currency", value);
                }}
                isDisabled={true}
              />
            </Form.Group>
            {formik.values.currency &&
            formik.values.currency !== generalSettings?.prevailingCurrency ? (
              <Form.Group>
                <CurrencyCustomInput
                  currencySymbol={"Ex. Rate"}
                  name="conversionAmount"
                  value={formik.values.conversionAmount}
                  onValueChange={(value, name) => {
                    formik.setFieldValue(name, value);
                  }}
                  placeholder="0.00"
                />
              </Form.Group>
            ) : null}
          </div>

          {!isEmpty(tableData) ? (
            <>
              <Table responsive borderless striped className="product-table border">
                <thead>
                  <tr>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    {!noVendorAccounting && <th>Vendor</th>}
                    <th>Unit Cost</th>
                    <th>Quantity</th>
                    <th>Amount Rcv</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.map((el, index) => (
                    <tr key={index} className="p-cursor">
                      <td>{el.Bar_Code}</td>
                      <td>
                        {el.Item_Name} <small>{el?.Batch_Name}</small>
                      </td>
                      {!noVendorAccounting && (
                        <td>
                          {el?.vendorName} <i>({el.InvoiceNo})</i>{" "}
                        </td>
                      )}
                      <td>{currency(el.UnitCost, { symbol: currencySymbol }).format()}</td>
                      <td>
                        {currency(el.Quantity, {
                          symbol: "",
                          precision: 2,
                          format: formatForQty,
                        }).format()}{" "}
                        {["Tons", "Pieces"].includes(el.Unit) ? el.Unit : ""}
                      </td>
                      <td>{currency(el.InvoiceAmount, { symbol: currencySymbol }).format()}</td>
                      <td className="text-nowrap">
                        {el.Date_Log ? formatDate(el.Date_Log) : "..."}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>

              {!noVendorAccounting ? (
                <>
                  <hr />
                  <div className="col-8 row mb-3">
                    <Form.Group className="col-6">
                      <Form.Label className="fw-5">Tax</Form.Label>
                      <Select
                        classNamePrefix="form-select"
                        placeholder="Select"
                        isSearchable={false}
                        value={taxOptions.find(el => el.value === formik.values.taxType)}
                        options={taxOptions}
                        onChange={selected => {
                          formik.setFieldValue("taxType", selected?.value || "None");
                          setTableData(oldData =>
                            oldData.map(el => ({ ...el, taxType: selected?.value || "None" }))
                          );
                        }}
                        isClearable
                      />
                    </Form.Group>

                    <Form.Group className="col-4">
                      <Form.Label className="fw-5">{formik.values.taxType}</Form.Label>
                      <CurrencyCustomInput
                        currencySymbol={currencySymbol}
                        name="tax"
                        value={taxValue}
                        onValueChange={(value, name) => {
                          //   formik.setFieldValue(name, value);
                        }}
                        placeholder="0.00"
                      />
                    </Form.Group>

                    <Form.Label className="col-2">
                      <Form.Label className="fw-5">&nbsp;</Form.Label>
                      <Form.Switch
                        className="text-nowrap"
                        label="Deduct Tax"
                        checked={formik.values.deductTax}
                        onChange={() => formik.setFieldValue("deductTax", !formik.values.deductTax)}
                      />
                    </Form.Label>
                  </div>
                  <hr />
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-5" htmlFor="invoice-file">
                      Add Attachments (Invoice, Job Completion etc)
                    </Form.Label>

                    <FilesAttachments
                      url={formik.values.invoiceFile}
                      files={formik.values.invoiceFile}
                      colWidth={12}
                      setFiles={files => formik.setFieldValue("invoiceFile", files)}
                    />
                  </Form.Group>
                  <hr />
                </>
              ) : null}

              {hasServiceItems && (
                <Form.Group className="mb-3 col-4">
                  <Form.Label>Select Service / Expense Account</Form.Label>
                  <InputGroup hasValidation>
                    <Form.Control
                      placeholder="Select Account"
                      value={`${formik.values?.expenseAccountID || ""} / ${formik.values
                        ?.expenseAccountDescription || ""} / ${formik.values?.expenseAccountType ||
                        ""}`}
                      onChange={() => {}}
                      readOnly
                    />

                    <Popover
                      isOpen={showJournalPopover}
                      onClickOutside={() => setShowJournalPopover(false)}
                      content={() => (
                        <ExpensesSelector
                          handleSelectedExpense={handleSelectedAccount}
                          usage={"chart of accounts"}
                          onHide={() => setShowJournalPopover(false)}
                          Type="EXPENSES"
                        />
                      )}
                      position="bottom"
                    >
                      <InputGroup.Text onClick={() => setShowJournalPopover(true)}>
                        <MagnifyIcon />
                      </InputGroup.Text>
                    </Popover>
                  </InputGroup>
                </Form.Group>
              )}

              <div className="d-flex justify-content-between save-btn-holder mt-4 w-100">
                <div className="d-flex flex-column gap-3 col-md-4">
                  <div className="gridChild gridChildBorderLeftBlue">
                    <div className="gridChildLeft">
                      <p className="gridChld1">
                        {currency(totalInvoiceAmount, {
                          symbol: currencySymbol,
                        }).format()}
                      </p>
                      <p className="gridChld2">Total Invoice Amount</p>
                    </div>
                  </div>

                  <div className="gridChild gridChildBorderLeftDarkerGreen">
                    <div className="gridChildLeft">
                      <p className="gridChld1">
                        {currency(totalInvoiceAmount, {
                          symbol: currencySymbol,
                        })
                          .add(taxValue)
                          .add(totalFreight)
                          .format()}
                      </p>
                      <p className="gridChld2">Total</p>
                    </div>
                  </div>
                </div>

                <Button
                  disabled={updateMutation.isLoading}
                  className="action-btn save-btn"
                  onClick={() => saveMulti({ ignoreDuplicateInvoice: false })}
                >
                  Post
                </Button>
              </div>
            </>
          ) : (
            <div className="no-item my-5 py-4">
              <div className="info">
                <NoSelectedItemIcon />
                <h2 className="mb-1">No Item Selected</h2>
                <p>
                  Please select an item and fill in the <br />
                  pricing details.
                </p>
              </div>
            </div>
          )}
        </div>
      </Modal.Body>

      <ModalLoader show={updateMutation.isLoading || isLoading} />
    </Modal>
  );
}
